import React, { PropTypes } from "react";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import { UserItem } from "components/Admin/User/List/UserItem";
import axios from "axios";
import FileSaver from "file-saver";
const {} = actions;

const titles = {
  name: "NAME",
  email: "EMAIL",
  user_type: "USER TYPE",
  county: "COUNTY",
  hospital: "HOSPITAL"
};

const {
  API_WEBINARS_VIEWED_USERS,
  API_WEBINARS_USERS
} = constants;

class UsersPopup extends React.Component {
  downloadCsvFile = (type) => {
    let url;
    if (type === 'attended') {
      url = API_WEBINARS_USERS;
    } else {
      url = API_WEBINARS_VIEWED_USERS;
    };

    axios
      .get(`${url}?id=${this.props.popupProps.id}`, {
        responseType: "blob"
      })
      .then(response => {
        // console.log(response);
        // console.log(response.headers["content-disposition"]);
        var effectiveFileName = "webinar_users.csv";
        FileSaver.saveAs(response.data, effectiveFileName);
      })
      .catch(error => {
        console.log(error);
      });
  };

  userItem = user => (
    <tr key={user.id}>
      <td>
        {user.first_name} {user.last_name}
      </td>
      <td>{user.email}</td>
      <td>{user.user_type}</td>
      <td>{user.county}</td>
      <td>{user.hospital}</td>
    </tr>
  );

  render() {
    const {popupProps} = this.props;
    console.log(this.props);
    return (
      <div className="admin_user_table admin_table">
        <table>
          <tr>
            {Object.keys(titles).map(value => (
              <th key={value}>{titles[value]}</th>
            ))}
          </tr>
          {this.props.users.map(user => this.userItem(user))}
        </table>
        {popupProps && (popupProps.type === "attended" || popupProps.type === "viewed" ) ? (
          <button onClick={() => this.downloadCsvFile(popupProps.type)} className="btn-download-csv">
            download CSV file
          </button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  popupProps: state.modal.modalContentProps.additional
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPopup);



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/UsersPopup.js
 **/